import { useEffect, useState } from "react";
import { _Affiliate, _ProcedureImp, _RequestCredit, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { PersonalAccountData } from "../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/PersonalAccountData";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../theme/Component/PrintJson";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}


interface Props {
    configProcedure: ProcedureFunctions;
}

export const CC001 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_RequestCredit);
    const [props, setProps] = useState<any>({});

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])


    const onExportMap = (obj?: any) => {
        const procedure = configProcedure._procedure

        instance.updateRequestCredit({ IDProcedureImp: procedure.IDProcedureImp, IDAccount: _single.getAccountID(), StateRequest: 1 });

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo("Se Actualizo la Informacion del usuario")
        }
        if (configProcedure?._exportMap) {
            configProcedure?._exportMap({ Obs: "Data Update" })
        }
        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ IDCreditAffiliate: obj?.IDCreditAffiliate, IDProcedureImp: procedure.IDProcedureImp })
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <PersonalAccountData idAffiliate={_single.getAccountID()} onClickSave={(e) => { onExportMap(e) }} />
            </div>
        </div>
    )
}